// extracted by mini-css-extract-plugin
export default {"root":"nxwJ_ySJ9q","name":"qAeKsBK0i3","count":"TifBC52U8P","count_bold":"wQV0wwF6_f"};